const swallow = (event: Event) => {
	event.preventDefault()
	event.stopPropagation()
}

// The drop's click can trail pointerup by a task in some browsers.
const RELEASE_MS = 50

// Dropping a row over its own link clicks that link; swallow clicks until it passes.
export function createClickGuard(target: EventTarget = window) {
	let listening: AbortController | null = null
	let timer: ReturnType<typeof setTimeout> | undefined

	const disarm = () => {
		clearTimeout(timer)
		timer = undefined
		listening?.abort()
		listening = null
	}

	return {
		arm() {
			clearTimeout(timer)
			if (listening) return
			listening = new AbortController()
			target.addEventListener("click", swallow, {
				capture: true,
				signal: listening.signal,
			})
		},
		release() {
			clearTimeout(timer)
			timer = setTimeout(disarm, RELEASE_MS)
		},
		dispose: disarm,
	}
}
